import { Language } from '../types'
import { t } from '../i18n'

interface ShareData {
  title: string
  text?: string
  url: string
}

export const shareContent = async (
  data: ShareData,
  lang: Language,
  showToast: (type: 'success' | 'error' | 'info', message: string) => void,
) => {
  // iPhone/Safari can sometimes be picky about ShareData structure
  const shareData = {
    title: data.title,
    text: data.text || '',
    url: data.url,
  }

  if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
    try {
      await navigator.share(shareData)
    } catch (err: any) {
      // User cancelled or share failed
      if (err.name !== 'AbortError') {
        console.warn('Native share interaction failed.', err)
        // Fallback to clipboard if share was intentional but failed
        await copyToClipboard(data.url, lang, showToast)
      }
    }
  } else {
    await copyToClipboard(data.url, lang, showToast)
  }
}

const copyToClipboard = async (
  url: string,
  lang: Language,
  showToast: (type: 'success' | 'error' | 'info', message: string) => void,
) => {
  try {
    // Modern approach
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url)
    } else {
      // Legacy fallback for some iOS browsers
      const textArea = document.createElement('textarea')
      textArea.value = url
      textArea.style.position = 'fixed'
      textArea.style.left = '-9999px'
      textArea.style.top = '0'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand('copy')
      textArea.remove()
    }
    showToast('success', t(lang, 'copySuccess'))
  } catch (err) {
    console.error('Copy to clipboard failed', err)
    showToast('error', t(lang, 'copyFailed'))
  }
}
